import React, { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
// import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

// import Cookies from '../../components/Cookies';
import Text from '../../components/Typography/Text';

import Container from '../Container';
import FooterNetworks from './FooterNetworks';
import FooterTerms from './FooterTerms';
import useBox from '../../uses/useBox';

import { IFooter } from './interfaces';

import networksJSON from './networks.json';

import { NavContext } from '../../providers/NavProvider';
import { INavContext } from '../../providers/NavProvider/interfaces';

import SiriusLogo from '../../assets/icons/sirius-logo';

import './styles.scss';

// footer
const Footer: FC<IFooter> = ({
  lang,
  type
}) => {
  const { t }: any = useTranslation();

  const { routes }: INavContext = useContext(NavContext);
  const { ref }: any = useBox();
  // const [cookies, setCookie] = useCookies(['novainfrainvest_cookie']);

  // render
  return (
    <>
      {/* {(!cookies?.novainfrainvest_cookie || cookies?.novainfrainvest_cookie === 'false') &&
        <Cookies
          bounding={box}
          cookie={cookies?.novainfrainvest_cookie}
          setCookie={setCookie} />}

      {type === 2 &&
        <NetworkShare
          lang={lang?.lang}
          type={2} />} */}

      <footer
        className="footer"
        data-type={type}
        ref={ref}>
        <Container>
          <Link className="copy" to="/">
            <Text>{t('copy')}</Text>
          </Link>

          <FooterNetworks items={networksJSON} />
          
          {routes && routes.filter((item: any) => item.navegacao === 'rodape').length !== 0 &&
          <FooterTerms 
            lang={lang?.lang} 
            items={routes ? routes.filter((item: any) => item.navegacao === 'rodape') : ''} 
          />
          }

          <a href='https://www.sirius.com.br/' className="footer-signature">
            Produzido por: 
            <SiriusLogo />
          </a>
        </Container>
      </footer>
    </>
  );
};

export default Footer;